module.exports = __webpack_public_path__ + "img/timer-red.5b68bdf5.svg";